import { render, staticRenderFns } from "./WorkflowMerchant.vue?vue&type=template&id=5d49bc00&"
import script from "./WorkflowMerchant.vue?vue&type=script&lang=js&"
export * from "./WorkflowMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports